import { fork } from "redux-saga/effects";
import { navigationMenuSaga } from "./state/sagas/NavigationMenuSaga";
import { quickLinksSaga } from "./state/sagas/QuickLinksSaga";
import { heroImageSaga } from "./state/sagas/HeroImagesSaga";
import { searchResultsSaga } from "./state/sagas/SearchResultsSaga";
import { initializeApplicationSaga } from "./state/sagas/InitializeApplicationSaga";
import { resourceLinksSaga } from "./state/sagas/ResourceLinksSaga";
import { searchKeyWordsSaga } from "state/sagas/SearchKeyWordsSaga";
import { footerSectionImagesSaga } from "state/sagas/FooterSectionImagesSaga";
import { recentlyUpdatedFilesSaga } from "state/sagas/RecentlyUpdatedFilesSaga";
import { currentNewsSaga } from "state/sagas/CurrentNewsSaga";
import { bannerImageSaga } from "state/sagas/BannerImageSaga";
import { textSizeSaga } from "state/sagas/TextSizeSaga";
import { titleTextsSaga } from "state/sagas/TitleTextsSaga";
import { spEnvironmentSaga } from "state/sagas/SPEnvironmentSaga";
import { howTosSaga } from "state/sagas/HowToSaga";
import { howToImagesSaga } from "state/sagas/HowToImagesSaga";
import { recentlyUpdatedPagesSaga } from "state/sagas/RecentlyUpdatedPagesSaga";

export default function* rootSaga() {
  yield fork(initializeApplicationSaga);
  yield fork(searchKeyWordsSaga);
  yield fork(searchResultsSaga);
  yield fork(resourceLinksSaga);
  yield fork(navigationMenuSaga);
  yield fork(quickLinksSaga);
  yield fork(heroImageSaga);
  yield fork(bannerImageSaga);
  yield fork(footerSectionImagesSaga);
  yield fork(recentlyUpdatedFilesSaga);
  yield fork(recentlyUpdatedPagesSaga);
  yield fork(titleTextsSaga);
  yield fork(currentNewsSaga);
  yield fork(textSizeSaga);
  yield fork(spEnvironmentSaga);
  yield fork(howTosSaga);
  yield fork(howToImagesSaga);
}
